import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getAdminNotificationSummary,
  listAdminNotifications,
  markAdminNotificationRead,
  markAllAdminNotificationsRead,
} from '../api/notificationsApi';
import { queryKeys } from '../api/queryKeys';

export function useAdminNotifications(filters = { page: 1, size: 10, tab: 'UNREAD' }) {
  return useQuery({
    queryKey: queryKeys.notifications.list(filters),
    queryFn: () => listAdminNotifications(filters),
    refetchInterval: 60_000,
  });
}

export function useAdminNotificationSummary() {
  return useQuery({
    queryKey: queryKeys.notifications.summary,
    queryFn: getAdminNotificationSummary,
    refetchInterval: 60_000,
  });
}

export function useAdminNotificationActions() {
  const queryClient = useQueryClient();
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.notifications.all });
  };

  const markRead = useMutation({
    mutationFn: markAdminNotificationRead,
    onSuccess: invalidate,
  });

  const markAllRead = useMutation({
    mutationFn: markAllAdminNotificationsRead,
    onSuccess: invalidate,
  });

  return { markRead, markAllRead };
}
